import React from "react"

export function SuccessAlert({txhash}) {

    return (

        <div className="row justify-content-center mt-5">
            <div class="alert alert-success" role="alert">
                感謝您的打賞，(交易紀錄: {txhash})
            </div>
        </div>
        
    )

}
